import React, { CSSProperties as css } from 'react';
import { useState } from "react";
import classNames from "classnames";
import { Link } from 'react-router-dom';
import {iProps} from "./types";
import { Button, ButtonSize, ButtonStyles } from '../../Button';
import "./index.scss";
import { useDispatch } from 'react-redux';
import { ReactComponent as SearchSVG } from '../../../assets/svg/search.svg';


import {
  Actions as ReportActions,
} from '../../../stores/reducers/report-reducers';

import {localStorage} from '../../../shared/storage';

const ReportTypeTab = ({ element, activeReportTypeTab, onClick }) => {
  const reportTypeTabElement = element.split('-').join(" ");
  return (
    <button
      onClick={onClick}
      className={classNames('only-one-option-search-item', {
        ['only-one-option-search-item_active']: activeReportTypeTab === element
      })}
    >
      {reportTypeTabElement}
    </button>
  );
}

const SearchGrid = ({
  perPage,
  list,
  RedirectToStatic,
  selectedCount,
  countOfSelectedFilters,
  currentFilterObject,
  filterType,
  filterChange,
  keyClicked,
  onReset,
  filterStr,
  placeholder,
  style = {},
  RedirectToTabs
}: iProps) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState({ currentPage: 1 });

  const [activeReportTypeTab, setActiveReportTypeTab] = useState(null);

  const handleTabClick = (element) => {
    dispatch(ReportActions.RESET_ALL_TYPE_FILTERS(filterType))
    setActiveReportTypeTab(element);

    dispatch(ReportActions.SET_TYPE_FROM_REDUX(element));
    keyClicked(element);
  };

  const { currentPage } = page;


  const displayItems = () => {
    const someFiltersMoreThanTwo = Object.entries(countOfSelectedFilters).some(
      ([key, value]) => value >= 2
    );

    const checkingAccessForMultipleFilters = ({ item }) => {
      const forAlerts =
        filterType == "alerts" &&
        !!currentFilterObject["alerts"] &&
        Object.keys(currentFilterObject["alerts"]).length == 1 &&
        Object.keys(currentFilterObject["alerts"])[0] !== item;


      const condition = forAlerts || (someFiltersMoreThanTwo && selectedCount == 1 && Object.keys(currentFilterObject[filterType])[0] !== item);
      const disableOtherFilter = condition ? true : false;
      return disableOtherFilter;
    };

    const loginToken = localStorage.get('login-init-be-token');

    if (Object.keys(list).length === 0) return <div className='no-results-title'>No results</div>

    const naturalSort = (a, b, order = "asc") => {
      const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: "base"
      });
      const cleanedA = a?.props?.children?.props?.title?.trim().replace(/\s+/g, " ") || "";
      const cleanedB = b?.props?.children?.props?.title?.trim().replace(/\s+/g, " ") || "";

      const comparison = collator.compare(cleanedA, cleanedB);

      return order === "asc" ? comparison : -comparison;
    };

    const ascSortedList = list.slice().sort((a, b) => naturalSort(a, b, "asc"));

    const listOfFilterItems = RedirectToTabs ? list : ascSortedList;

    return listOfFilterItems
      .map((element) => {
        const disableFilters = checkingAccessForMultipleFilters({
          item: element.key,
        });

        if(element.key === 'permissions' && !loginToken['do-anything']) return;

        return RedirectToStatic ? (
          <Link
            key={element.key}
            to={RedirectToStatic && "static"}
            className={classNames('only-one-option-search-item', {
              disable: disableFilters ? true : false,
            })}
            onClick={(_) => keyClicked(element.key.toString())}
          >
            {element}
          </Link>
        ) : RedirectToTabs ? (
          <ReportTypeTab
            key={element.key}
            element={element.key.toString()}
            activeReportTypeTab={activeReportTypeTab}
            onClick={() => handleTabClick(element.key.toString())}
          />
        ) : (
          <div
            key={element.key}
            className={classNames({
              "search-item": true,
              disable: disableFilters ? true : false,
            })}
            onClick={(_) => keyClicked(element.key.toString())}
          >
            {element}
          </div>
        );
      });
  };

  const pageCount = () => {
      return Math.ceil(list.length / perPage );
  }

  const countOfPages = pageCount();

  const searchFilters = ({ target }) => {
    filterChange(target.value);
  }

  const changePage = (amount) => {
      setPage((state) => {
        let newPage = state.currentPage + amount;

        if (newPage < 1) newPage = 1;
        if (newPage > countOfPages) newPage = countOfPages;

        return { currentPage: newPage };
      });
  }

  return (
    <div className="search-grid" style={style}>
      <div className="search-grid-search">
        <div className="search">
          <SearchSVG className="search-icon" />
          <input
            type="text"
            placeholder={placeholder}
            value={filterStr}
            onChange={searchFilters}
          />
        </div>
      </div>
      {(RedirectToStatic || RedirectToTabs) ? (
        <div className="search-items">{displayItems()}</div>
      ) : (
          <div className="checkbox-search-items">
            <div className="checkbox-list">
              {displayItems()}
            </div>
            <div className="reset-to-all-button" onClick={onReset}>
              <Button styleType={ButtonStyles.BLACK_WHITE} size={ButtonSize.MD}>
                Clear all
              </Button>
            </div>
          </div>
      )
      }
    </div>
  );
};

export default SearchGrid;